/**
 * Entidade de Domínio: Product
 * Responsabilidade: Representa um produto com suas regras de negócio
 * Princípios: Single Responsibility, Encapsulation
 */

export class Product {
    constructor(
        public readonly id: string,
        public name: string,
        private value: number,
        public description: string = '',
        public readonly createdAt: Date = new Date(),
        public readonly updatedAt: Date = new Date(),
        public readonly createdBy?: string
    ) {
        this.validate();
    }

    private validate(): void {
        if (!this.name || this.name.trim().length < 1) {
            throw new Error('Nome do produto é obrigatório');
        }

        if (this.value < 0) {
            throw new Error('Valor do produto não pode ser negativo');
        }

        if (this.description.length > 100) {
            throw new Error('Descrição deve ter no máximo 100 caracteres');
        }
    }

    // Getters
    getValue(): number {
        return this.value;
    }

    getFormattedValue(): string {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(this.value);
    }

    // Métodos de negócio
    updateValue(newValue: number): void {
        if (newValue < 0) {
            throw new Error('Valor não pode ser negativo');
        }
        this.value = newValue;
    }

    updateName(newName: string): void {
        if (!newName || newName.trim().length < 1) {
            throw new Error('Nome do produto é obrigatório');
        }
        this.name = newName.trim();
    }

    updateDescription(newDescription: string): void {
        if (newDescription.length > 100) {
            throw new Error('Descrição deve ter no máximo 100 caracteres');
        }
        this.description = newDescription;
    }

    // Regras de negócio
    isExpensive(): boolean {
        return this.value >= 1000;
    }

    canBeDeleted(): boolean {
        // Produtos sempre podem ser deletados (não há restrições de negócio)
        return true;
    }
}
